<template>
  <div class="changeLocaleComponents">
    <el-dropdown @command="handleCommand" trigger="click" placement="top-end">
      <span class="el-dropdown-link cursor">
        <span class="local">{{ LOCALE | navLocaleFormat }}</span>
        <i class="el-icon-caret-bottom el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="zh">简体中文-CHN</el-dropdown-item>
        <el-dropdown-item command="en">English-EN</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import baseConfig from "~/baseConfig";
export default {
  methods: {
    handleCommand(command) {
      let currentEnvDomains =
        baseConfig.projectConfig[process.env.VUE_APP_PROJECT_NAME].domainNames[
          process.env.VUE_APP_API_ENV
        ];
      if (command == this.LOCALE) {
        return;
      }
      let host = window.location.host;
      let preHost = `${window.location.protocol}//`;
      let route = this.$route.fullPath;
      // if (route == "/") {
      //   route = "";
      // }
      let oldRoute = route;

      let currentNames =
        currentEnvDomains.find((item) => {
          return item[this.LOCALE] == host;
        }) || host;
      let address = "";

      let fullPath = this._encode(oldRoute);
      if (this.IS_LOGIN) {
        address = `${preHost}${currentNames[command]}/handleInitialParams?initialParams=${this.USER_ID}&redirect_url=${fullPath}`;
      } else {
        address = `${preHost}${currentNames[command]}/handleInitialParams?redirect_url=${fullPath}`;
      }
      window.location.href = address;
    },
  },
};
</script>

<style lang="less" scoped>
.changeLocaleComponents {
  width: 100%;
  .local {
    color: #606266;
  }
}
</style>